import React from 'react';
import { Box, Typography, Card, CardMedia, MobileStepper, Button, styled, useTheme, useMediaQuery } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import image from '../../Assets/images/fresh.png';

// Replace with your actual image data
const featuredItems = [
  {
    label: 'New discoveries and secrets to a glowing skin even after 50 years',
    imgPath: image, // Placeholder image
  },
  // Add more items
];

const RecommendationsContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  width: '100%',
}));

const RecommendationsTitle = styled(Typography)(({ theme }) => ({
  variant: 'h6',
  fontWeight: theme.typography.fontWeightSemiBold,
  color: theme.palette.grey[800],
  marginBottom: theme.spacing(2),
  textAlign: 'center', // Center title on mobile
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  position: 'relative',

}));

const ImageOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  background: 'linear-gradient(to-t, rgba(0,0,0,0.8) 0%, transparent 100%)',
  color: theme.palette.common.white,
  padding: theme.spacing(2),
  width: '100%',
}));

const OverlayTitle = styled(Typography)(({ theme }) => ({
  variant: 'h6',
  fontWeight: theme.typography.fontWeightSemiBold,
  textAlign: 'center', // Center overlay title on mobile
}));

const StyledMobileStepper = styled(MobileStepper)(({ theme }) => ({
  backgroundColor: 'transparent',
  justifyContent: 'center', // Center buttons on mobile
  padding: theme.spacing(1),
}));

const FriendRecommendations = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = featuredItems.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <RecommendationsContainer>
      <RecommendationsTitle>
        Freshly Squeezed for you
      </RecommendationsTitle>
      <StyledCard>
        <CardMedia
          component="img"
          height={isMobile ? '200' : 'auto'} // Adjust height for mobile
          image={featuredItems[activeStep].imgPath}
          alt={featuredItems[activeStep].label}
          sx={{width: '100%', objectFit: 'cover'}} // Ensure image covers the card
        />
        <ImageOverlay>
          <OverlayTitle>
            {featuredItems[activeStep].label}
          </OverlayTitle>
          {/* You might add a short excerpt here */}
        </ImageOverlay>
      </StyledCard>
      {featuredItems.length > 1 && (
        <StyledMobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
              Next
              {theme.direction === 'ltr' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
              {theme.direction === 'ltr' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
              Back
            </Button>
          }
        />
      )}
    </RecommendationsContainer>
  );
};

export default FriendRecommendations;